import Parser from 'html-react-parser';
import { TagFill } from 'react-bootstrap-icons';
import { set } from 'features/app/appSlice';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RenderedInteractiveContent } from 'pages/documents_v2/views/edit_area/blocks/RenderedInteractiveContent';
import { useContext } from 'react';
import { EditAreaContext } from 'pages/documents_v2/views/edit_area/context/EditAreaContext';

export function RenderedTextContent({ block, baseBlock, highlightedContent, index, dirty = false }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { hideChanges } = useContext(EditAreaContext);

    if (baseBlock && baseBlock.changes.length > 0 && !hideChanges && !dirty) {
        return (
            <RenderedInteractiveContent block={baseBlock} content={baseBlock.diffContent ?? baseBlock.latestContent} />
        );
    }

    return (
        <>
            {Parser(highlightedContent, {
                replace: ({ attribs }) => {
                    if (attribs && attribs.class === 'tags-button') {
                        const tagValue = attribs['data-tag'];

                        return (
                            <span
                                data-uk-tooltip={t(
                                    'documents:document.navbar.main.editor.left.blocks.tooltips.editTag',
                                )}
                                className="tags-button"
                                onClick={(e) => handleTagButtonClick(e, tagValue)}
                            >
                                <TagFill size={12} className="mr-1" />
                                {tagValue}
                            </span>
                        );
                    }
                },
            })}
        </>
    );

    function handleTagButtonClick(e, tagValue) {
        e.stopPropagation();

        dispatch(
            set({
                key: 'blockEditModal',
                value: {
                    eventKey: 'editTagModal',
                    block,
                    blockIndex: index,
                    tag: tagValue,
                },
            }),
        );
    }
}
